import gql from 'graphql-tag';

import configFragment from '../fragments/configFragment';

export default gql`
  query config {
    config {
      ...configFragment
    }
  }
  ${configFragment}
`;
